import { render, staticRenderFns } from "./Pelamar.vue?vue&type=template&id=22cb2ce0&scoped=true&"
import script from "./Pelamar.vue?vue&type=script&lang=js&"
export * from "./Pelamar.vue?vue&type=script&lang=js&"
import style0 from "./Pelamar.vue?vue&type=style&index=0&id=22cb2ce0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb2ce0",
  null
  
)

export default component.exports